'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { shallowCompare } from 'reporting-ui-components/lib/shallowCompareReports';
import { Map as ImmutableMap, List } from 'immutable';
import ReportWithData from './inferLogic/components/ReportWithData';
import { fromDataset } from 'reporting-data/v2/dataset/convert';
import { jsx as _jsx } from "react/jsx-runtime";
const validateReport = report => {
  report = !report.getIn(['config', 'dimensions']) ? report.setIn(['config', 'dimensions'], List()) : report;
  return report;
};
class ReportGenerator extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  render() {
    const {
      data
    } = this.props;
    const report = validateReport(this.props.report);
    const upgradedData = fromDataset(report.get('config'), data);
    const dataset = ImmutableMap({
      primary: ImmutableMap({
        config: report.get('config'),
        data: upgradedData
      })
    });
    const reportHasData = dataset.getIn(['primary', 'data', 'data']).count() > 0;
    return /*#__PURE__*/_jsx(ReportWithData, {
      report: report,
      configuredReport: report,
      reportData: dataset,
      reportHasData: reportHasData,
      reportLoading: false
    });
  }
}
ReportGenerator.propTypes = {
  report: PropTypes.object,
  data: PropTypes.object,
  upgradeToV2: PropTypes.bool
};
export default ReportGenerator;